<div class="row mb-3">
    <div class="col-3">
        <img class="image-icon-sm" src="content/images/measurements.svg" />
        <span class="d-inline-flex p-2 h5 fw-bold">{{ 'study-editor.inventory.title' | translate}}</span>
    </div>
</div>
<div class="row mb-2">
    <div class="col d-flex justify-content-start align-items-center">
        <label>{{ 'study-editor.inventory.select-environment' | translate}}</label>
        <div class="col-3 ms-2">
            <ng-select [items]="environments" [ngModel]="selectedEnvironment" (ngModelChange)="onEnvironmentChange($event)" [clearable]="false">
                <ng-template ng-label-tmp let-item="item">
                    @if (item?.instanceNumber) {
                        {{ item?.instanceNumber }} -
                    }
                    @if (item?.locationName === 'All environments') {
                        {{ 'study-editor.all-environments' | translate }}
                    } @else {
                        {{ item?.locationName }}
                    }

                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-index="index">
                    @if (item?.instanceNumber) {
                        {{ item?.instanceNumber }} -
                    }
                    @if (item?.locationName === 'All environments') {
                        {{ 'study-editor.all-environments' | translate }}
                    } @else {
                        {{ item?.locationName }}
                    }
                </ng-template>
            </ng-select>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-12">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <div class="col">
                    <span jhiTranslate="global.total.entries" [translateValues]="{param: numberOfEntries}"></span>
                </div>

            </div>
        </div>
    </div>
</div>
<div class="container-fluid mt-3 ps-0 pe-0">
    <!-- Germplasm Study Source Table Section -->
    <div>
        <div class="row">
            <div class="col-10">
                <div class="col d-flex align-items-center">
                    <label class="col-auto" jhiTranslate="global.records.per.page">Records per page: </label>
                    <div class="col-1 ms-2">
                        <select class="form-select form-select-sm"
                                [(ngModel)]="pageSize"
                                (change)="onPageSizeChange($event)">
                            <option value="50">50</option>
                            <option value="75">75</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                    <div class="col-5 d-flex align-items-center justify-content-start">
                            <jhi-selection-count [showSelectAll]="true"
                                                 [isSelectAll]="isSelectAll"
                                                 [totalItemsSize]="numberOfFilteredEntries || numberOfEntries"
                                                 [selectedItemsSize]="selectedItems.size"
                                                 (deselectAction)="clearSelected()"
                                                 (selectAllAction)="selectAll($event)"
                                                 (reset)="onColumnSelectorReset()"
                                                ></jhi-selection-count>
                            <button class="btn btn-sm btn-outline-info ms-2" (click)="clearFilters()"><i class="fa fa-filter-circle-xmark me-1"></i>
								<span jhiTranslate="study-editor.clear.filter">Clear Filter</span></button>
                    </div>
                </div>
            </div>
            <div class="col-2 d-flex justify-content-end align-items-center">
                @if (hasCancelPendingTransactionsPermission) {
                    <div ngbDropdown container="body" class="d-inline-block ps-2" placement="bottom-right">

                        <button class="btn btn-sm btn-info" id="columnsDropdown" ngbDropdownToggle>
                            <span>{{ 'study-editor.inventory.actions' | translate}}</span>
                        </button>
                        <div ngbDropdownMenu aria-labelledby="columnsDropdown">
                            <button ngbDropdownItem type="button" class="dropdown-item" (click)="cancelPendingTransactions()">
                                <span class="ms-1">{{ 'study-editor.inventory.actions.cancel-pending-transactions' | translate}}</span>
                            </button>
                        </div>
                    </div>
                }
                <div class="ms-1">
                    <jhi-column-selector [displayedColumns]="displayedColumns"
                                         [columnDataService]="columnDataService"
                                         (reset)="onColumnSelectorReset()"
                                         [showGroupToggle]="false"></jhi-column-selector>
                </div>
            </div>
        </div>
        <!-- Data Table -->
        <div class="table-responsive mt-3">
            <div class="custom-scroll-style adjustable-height">
                <table id="germplasm-checks-table"
                       class="table table-striped table-bordered table-curved table-editable">
                    <thead class="sticky-header">
                    <tr>
                        @for (column of displayedColumns; track trackColumnsById(column)) {
                            @if (column.selected && column.visible) {
                                <th class="default">
                                    @if (getStaticColumnLabelKey(column.termId)) {
                                        {{getStaticColumnLabelKey(column.termId) | translate}}
                                    } @else {
                                        {{ column.displayName }}
                                    }

                                    @if (column.termId === CHECKBOX) {
                                        <input type="checkbox" class="form-check-input m-1"
                                               [ngbTooltip]="'global.select.current.page' | translate"
                                               [checked]="isPageSelected()"
                                               (click)="onSelectPage()">
                                    }

                                    @if (column.id !== CHECKBOX) {
                                        <span class="cursor-pointer ms-1"
                                              #p="ngbPopover"
                                              (click)="showColumnFilterPopover(column, p)"
                                              [autoClose]="'outside'"
                                              [ngbPopover]="columnFilterTemplate"
                                              container="body"
                                              [placement]="['bottom', 'right', 'auto']"
                                              triggers="manual">
                                    <i class="fa fa-filter ps-1" [ngClass]="{'filtering-by': column.isFiltered}"></i>
                                            @if (column.sortingAsc !== undefined && column.sortingAsc !== null) {
                                                <i class="ps-1 fa fa-icon-active"
                                                   [ngClass]="{'fa-sort-asc': column.sortingAsc, 'fa-sort-desc': !column.sortingAsc}">
                                        </i>
                                            }
                                </span>
                                    }
                                </th>
                            }
                        }
                    </tr>
                    </thead>
                    <tbody>
                        @if (entries.length !== 0) {
                            @for (entry of entries; track trackRowsById(entry); let row = $index) {
                                <tr
                                        (click)="toggleSelect($event, row, entry); $event.stopPropagation()"
                                        [class.selected]="isSelected(entry.transactionId)"
                                        (mousedown)="preventDefaultOnShiftKey($event)">
                                    @for (column of displayedColumns; track trackColumnsById(column); let col = $index) {
                                        <td *ngIf="column.selected && column.visible">
                                            @switch (true) {
                                                @case (CHECKBOX === column.id) {
                                                    <input type="checkbox" class="form-check-input m-1"
                                                           [checked]="isSelected(entry.transactionId)"
                                                           (change)="toggleSelect($event, row, entry, true)"
                                                           (click)="$event.stopPropagation()"/>
                                                }
                                                @case (STATIC_COLUMN_TRIAL_INSTANCE === column.id) {
                                                   {{ getInstanceNumberDisplay(entry) }}
                                                }
                                                @case (STATIC_COLUMN_TRANSACTION_ID === column.id) {
                                                    @if (entry.transactionId) {
                                                        <a  href="javascript:void(0)" class="link" (click)="openTransactionAdditinalDetailsModal(entry)">{{ entry.transactionId }}</a>
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (STATIC_COLUMN_ENTRY_TYPE === column.id) {
                                                    @if (entry.observationUnits[0]?.entryType) {
                                                        {{ entry.observationUnits[0]?.entryType }}
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (STATIC_COLUMN_GID === column.id) {
                                                    @if (entry.lot.gid && hasViewGermplasmDetailsPermission) {
                                                        <a  href="javascript:void(0)" class="link" (click)="germplasmDetailsPopupService.open(entry.lot.gid)"><truncate-span [textInput]="entry.lot.gid"></truncate-span></a>
                                                    } @else if (entry.lot.gid){
                                                        <truncate-span [textInput]="entry.lot.gid"></truncate-span>
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (STATIC_COLUMN_DESIGNATION === column.id) {
                                                    @if (entry.lot.designation && hasViewGermplasmDetailsPermission) {
                                                        <a  href="javascript:void(0)" class="link" (click)="germplasmDetailsPopupService.open(entry.lot.gid)"><truncate-span [textInput]="entry.lot.designation" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></a>
                                                    } @else if (entry.lot.designation) {
                                                        <truncate-span [textInput]="entry.lot.designation" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span>
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (STATIC_COLUMN_ENTRY_NO === column.id) {
                                                    @if (entry.observationUnits[0]?.entryNo) {
                                                        {{ entry.observationUnits[0]?.entryNo }}
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (STATIC_COLUMN_PLOT_NO === column.id) {
                                                    @if (entry.observationUnits[0]?.plotNo) {
                                                        {{ entry.observationUnits[0]?.plotNo }} <span>{{ entry.observationUnits.length > 1 ? 'and more...' : '' }}</span>
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (STATIC_COLUMN_LOT_STORAGE_LOCATION_ABBREVIATION === column.id) {
                                                    @if (entry.lot.locationAbbr) {
                                                        {{ entry.lot.locationAbbr }}
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (STATIC_COLUMN_STOCK_ID === column.id) {
                                                    @if (entry.lot.stockId) {
                                                        <a  href="javascript:void(0)" class="link" (click)="openViewTransactionsModal(entry.lot.gid, entry.lot.lotId)"> <truncate-span [textInput]="entry.lot.stockId"></truncate-span> </a>
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (STATIC_COLUMN_CREATED_DATE === column.id) {
                                                    @if (entry.createdDate) {
                                                        {{ entry.createdDate }}
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (STATIC_COLUMN_CREATED_BY_USERNAME === column.id) {
                                                    @if (entry.createdByUsername) {
                                                        {{ entry.createdByUsername }}
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (STATIC_COLUMN_LOT_TRANSACTION_TYPE === column.id) {
                                                    @if (entry.transactionType) {
                                                        {{ 'inventoryManagerApp.transaction.type.' + entry.transactionType | translate }}
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (STATIC_COLUMN_LOT_TRANSACTION_STATUS === column.id) {
                                                    @if (entry.transactionStatus) {
                                                        {{ 'inventoryManagerApp.transaction.status.' + entry.transactionStatus | translate }}
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (STATIC_COLUMN_LOT_UNIT === column.id) {
                                                    @if (entry.lot.unitName) {
                                                        {{ entry.lot.unitName }}
                                                    } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (STATIC_COLUMN_LOT_AMOUNT === column.id) {
                                                    @if (entry.amount) {
                                                        {{ entry.amount }}
                                                                } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @case (STATIC_COLUMN_LOT_NOTES === column.id) {
                                                    @if (entry.notes) {
                                                        {{ entry.notes }}
                                                                } @else {
                                                        <span>-</span>
                                                    }
                                                }
                                                @default {
                                                }
                                            }
                                        </td>
                                    }
                                </tr>
                            }
                        } @else {
                            <tr>
                                <td [attr.colspan]="displayedColumns.length" class="text-center py-3">
                                    {{ 'study-editor.no-records' | translate }}
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
        <div class="d-flex justify-content-between align-items-center mt-3">

            <div>
				@if (numberOfEntries !== numberOfFilteredEntries) {
					<span name="pageDescription" class="text-muted" jhiTranslate="study-editor.pagination.entry-count"
						  [translateValues]="{param1: (currentPage - 1) * pageSize + 1, param2: Math.min(currentPage * pageSize, numberOfFilteredEntries), param3: numberOfFilteredEntries}"></span>
					<span class="text-muted" jhiTranslate="study-editor.pagination.entry-total-count" [translateValues]="{param: numberOfEntries}"></span>
				} @else {
					<span name="pageDescription" class="text-muted" jhiTranslate="study-editor.pagination.entry-count"
						  [translateValues]="{param1: (currentPage - 1) * pageSize + 1, param2: Math.min(currentPage * pageSize, numberOfFilteredEntries), param3: numberOfEntries}"></span>
				}
            </div>

            <div>
                <div class="d-inline-block ms-3">
                    <ngb-pagination
                            [collectionSize]="numberOfFilteredEntries || numberOfEntries"
                            [(page)]="currentPage"
                            [pageSize]="pageSize"
                            [maxSize]="10"
                            [ellipses]="true"
                            [boundaryLinks]="true"
                            [rotate]="true"
                            (pageChange)="onPageChange($event)">
                    </ngb-pagination>
                </div>
                <div class="d-inline-block ms-3">
                    <label for="goToPage" class="me-2" jhiTranslate="study-editor.pagination.go-to">Go to page:</label>
                    <input id="goToPage" type="number" class="form-control d-inline-block w-auto"
                           [min]="1" [max]="Math.ceil((numberOfFilteredEntries || numberOfEntries) / pageSize)"
                           [(ngModel)]="currentPage"
                           (change)="onPageChange(currentPage); $event.preventDefault()"/>
                </div>
            </div>
        </div>
    </div>
</div>



<!-- Column Filter Template -->
<ng-template #columnFilterTemplate>
    <div class="column-filter">
        <!-- Sorting Buttons -->
        <div class="btn-group w-100" role="group" *ngIf="columnDataForFilter.enableFilterSorting !== false">
            <button (click)="sortColumn(columnDataForFilter,true)" class="btn btn-o"
                    [ngClass]="columnDataForFilter.sortingAsc === true ? 'btn-info' : 'btn-outline-secondary'">
                <i class="fa fa-sort-alpha-asc fw-bold fs-6"></i>
            </button>
            <button (click)="sortColumn(columnDataForFilter,false)" class="btn"
                    [ngClass]="columnDataForFilter.sortingAsc === false ? 'btn-info' : 'btn-outline-secondary'">
                <i class="fa fa-sort-alpha-desc fw-bold fs-6"></i>
            </button>
        </div>
        @if (columnDataForFilter.dataTypeCode === 'NUMERIC_LIST') {
            <div class="mt-2">
                <input class="form-control"
                       [(ngModel)]="columnDataForFilter.query"
                       placeholder="{{ 'column-filter.comma.separated.values.placeholder' | translate }}">
            </div>
        }
        @if (columnDataForFilter.dataTypeCode === 'TEXT') {
            <div class="mt-2">
                <input class="form-control"
                       [(ngModel)]="columnDataForFilter.query"
                       placeholder="{{ 'column-filter.contains.text.placeholder' | translate }}">
            </div>
        }
        @if (columnDataForFilter.dataTypeCode === 'DATE') {
            <div class="mt-2">
                <div class="mb-3 row">
                    <label for="from" class="col-form-label col-md-3" jhiTranslate="study-editor.inventory.field.from">From</label>
                    <div class="input-group col-md-9">
                        <input class="form-control" [placeholder]="'global.date.placeholder' | translate"
                               name="from" [(ngModel)]="columnDataForFilter.from" [maxDate]="columnDataForFilter.to"
                               ngbDatepicker [autoClose]="false" #from="ngbDatepicker" id="from">
                        <button class="btn btn-outline-secondary calendar" (click)="from.toggle()" type="button"><i class="fa fa-calendar"></i></button>
                    </div>
                </div>
                <div class="mb-3 row">
                    <label for="to" class="col-form-label col-md-3" jhiTranslate="study-editor.inventory.field.to">To</label>
                    <div class="input-group col-md-9">
                        <input class="form-control" [placeholder]="'global.date.placeholder' | translate"
                               name="to" [(ngModel)]="columnDataForFilter.to"
                               ngbDatepicker [autoClose]="false" #to="ngbDatepicker" id="to">
                        <button class="btn btn-outline-secondary calendar" (click)="to.toggle()" type="button"><i class="fa fa-calendar"></i></button>
                    </div>
                </div>
            </div>
        }
        @if (columnDataForFilter.dataTypeCode === 'OPTIONS') {
            <div class="mt-2">
                <div class="form-check" *ngFor="let option of columnDataForFilter.options">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="option.checked"
                           id="check-{{option.id}}" name="check-{{option.id}}">
                    <label class="form-check-label" for="check-{{option.id}}">
                        {{option.name}}
                    </label>
                </div>
            </div>
        }
        @if (columnDataForFilter.dataTypeCode === 'NUMERIC_RANGE') {
            <div class="mt-2">
                    <div class="mb-3 row">
                        <label for="min" class="col-form-label col-md-3" jhiTranslate="study-editor.inventory.field.min">Min</label>
                        <div class="col-md-9">
                            <input type="number" class="form-control" id="min" [(ngModel)]="columnDataForFilter.min" placeholder="{{'study-editor.inventory.field.min.value' | translate}}">
                        </div>
                    </div>
                    <div class="mb-3 row">
                        <label for="max" class="col-form-label col-md-3" jhiTranslate="study-editor.inventory.field.max">Max</label>
                        <div class="col-md-9">
                            <input type="number" class="form-control" id="max"  [(ngModel)]="columnDataForFilter.max"  placeholder="{{'study-editor.inventory.field.max.value' | translate}}">
                        </div>
                    </div>
                    <div class="alert alert-danger" *ngIf="columnDataForFilter.min > columnDataForFilter.max">
						<span jhiTranslate="study-editor.inventory.error.max.higher.than.min">Max must be higher than min</span>
                    </div>
            </div>
        }
        <!-- Action Buttons -->
        <div class="mt-3">
            <div class="d-flex justify-content-around">
                <div>
                    <button class="btn btn-info ms-2"
                            (click)="filterByColumn(columnDataForFilter)"
                            title="{{ 'global.apply.all.filter' | translate }}" jhiTranslate="apply"
                            [disabled]="!isApplyAllEnabled(columnDataForFilter)">
                        Apply
                    </button>
                    <button class="btn btn-secondary ms-2"
                            (click)="resetFilterByColumn(columnDataForFilter)"
                            title="{{ 'global.reset.filter' | translate }}" jhiTranslate="reset">
                        Reset
                    </button>
                </div>
            </div>
        </div>
    </div>

</ng-template>
